var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7904 12.29L13.2004 9.7C12.8104 9.31 12.1804 9.31 11.7904 9.7L9.20044 12.29C8.57044 12.92 9.02044 14 9.91044 14L15.0904 14C15.9804 14 16.4204 12.92 15.7904 12.29Z",
    fill: "#388078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeLess);
export default __webpack_public_path__ + "static/media/seeLess.5d53651a50a52199abb1d00d54b40dd8.svg";
export { ForwardRef as ReactComponent };